var magnificPopup = $.magnificPopup.instance;

$('.gallery-thumb').magnificPopup({
  type:'inline',
  showCloseBtn: false,
  autoFocusLast: true,
  focus:"#close-btn",
  gallery: {
    enabled: true,
    arrowMarkup:''
  }
});

$('body').on('click', '.gallery-popup-nav-prev', function() {
  event.preventDefault();
  magnificPopup.prev();
});

$('body').on('click', '.gallery-popup-nav-next', function() {
  event.preventDefault();
  magnificPopup.next();
});

$('body').on('click', '#close-btn', function() {
  event.preventDefault();
  $.magnificPopup.close();
});

$('.popup-image').magnificPopup({
  type: 'image',
  gallery: {
    enabled: true
  }
});

$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
  disableOn: 700,
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});
